export const crumbMap: Record<string, string> = {
  '/dashboard': 'Dashboard',
  '/wallets': 'Wallet Overview',
  '/transactions': 'Transactions Overview',
  '/user-management': 'User Management',
  '/customers': 'Corporate Customer',

  // Checkout Routes
  '/checkout/prefix-mapping': 'Prefix Mapping',
  '/checkout/beneficiaries': 'Embedly Collect',
};

export const dynamicCrumbMap: Record<string, string> = {
  // Dashboard
  dashboard: 'Wallets',

  // Wallets Dynamic Route
  wallets: 'Wallet Details',
  transactions: 'Transaction Details',
  organization: 'Organization Wallets',
  'user-management': 'User Profile',

  // Checkout Routes
  'prefix-mapping': 'Checkout Wallets',

  beneficiaries: 'Beneficiary Details',
};

export const NON_PAGE_RULES = [
  {
    segment: 'wallet',
    parentStartsWith: '/checkout/prefix-mapping/',
  },
];

export function isNonPageSegment(segment: string, parentPath: string) {
  return NON_PAGE_RULES.some(
    (rule) =>
      rule.segment === segment && parentPath.startsWith(rule.parentStartsWith)
  );
}

// export const crumbList = [
//   {
//     path: '/',
//     breadcrumb: null,
//   },
//   {
//     path: '/dashboard',
//     breadcrumb: 'Dashboard',
//   },
//   {
//     path: '/dashboard/:organizationId',
//     breadcrumb: 'wallet',
//   },
//   {
//     path: '/dashboard/wallets',
//     breadcrumb: 'All Organization Wallets',
//   },
//   {
//     path: '/wallets',
//     breadcrumb: 'Wallet overview',
//   },
//   {
//     path: '/wallets/:id',
//     breadcrumb: 'wallets',
//   },
//   {
//     path: '/wallets/organization/:organizationId',
//     breadcrumb: 'wallets',
//   },
//   {
//     path: '/transactions',
//     breadcrumb: 'Transactions overview',
//   },
//   {
//     path: '/transactions/:id',
//     breadcrumb: 'transactions',
//   },
//   {
//     path: '/user-management',
//     breadcrumb: 'User Management',
//   },
//   {
//     path: '/user-management/:id',
//     breadcrumb: 'User Profile',
//   },

//   // Customers Module Breadcrumb
//   {
//     path: '/customers',
//     breadcrumb: 'Corporate Customer',
//   },
//   {
//     path: '/customers/:id',
//     breadcrumb: 'Customer Details',
//   },

//   // Cashback Module Breadcrumb
//   {
//     path: '/cashback/configurations',
//     breadcrumb: 'Cashback',
//   },
//   {
//     path: '/cashback/configurations/:configId',
//     breadcrumb: 'Configuration Details',
//   },

//   // Checkout Module
//   {
//     path: '/checkout/prefix-mapping',
//     breadcrumb: 'Checkout Accounts',
//   },
//   {
//     path: '/checkout/prefix-mapping/:id',
//     breadcrumb: 'Checkout Wallets',
//   },
//   {
//     path: '/checkout/prefix-mapping/:id/transactions/:id',
//     breadcrumb: 'Checkout Transactions',
//   },
//   {
//     path: '/checkout/prefix-mapping/:id/wallet/:id',
//     breadcrumb: 'Wallet details',
//   },
// ];

export const hiddenBreadcrumbPaths = ['/'];
// export const hiddenBreadcrumbPaths = ['/', '/dashboard'];
